import { Card, Stack, Text } from '@etg/wings';
import { ArrowSquareOut } from '@phosphor-icons/react';
import { css, cx } from '@eti/styles';
import { useDirection, useTranslation } from '@eti/providers';
import { linkStyles } from '../../../../../utils/styleUtils';

const aTagStyles = css`
  align-items: center;
  display: flex;
  gap: 4px;
`;

const descriptionStyles = css`
  padding-top: 8px;
`;

interface DrawerReadMoreProps {
  carrierName: string;
}
const DrawerReadMore = ({ carrierName }: DrawerReadMoreProps) => {
  const { t } = useTranslation();
  const { isRTL } = useDirection();

  return (
    <Card data-testid="read-more-section">
      <Stack align="start" spacing={4}>
        <Text>
          {t('OrderDetails.CarrierVerification.Drawer.ReadMore.ImportantNote', carrierName)}
        </Text>
        <Text className={descriptionStyles}>
          {t('OrderDetails.CarrierVerification.Drawer.ReadMore.Description')}
        </Text>
        <a
          className={cx(linkStyles, aTagStyles)}
          data-testid="read-more-link"
          href={t('OrderDetails.CarrierVerification.Drawer.ReadMore.Url')}
          rel="noreferrer"
          target="_blank"
        >
          <Text>{t('ReadMore')}</Text>
          <ArrowSquareOut mirrored={isRTL} size={19} weight="light" />
        </a>
      </Stack>
    </Card>
  );
};

export default DrawerReadMore;
